
import { el } from "element-plus/lib/locale";
import appAxios from "../../utils/appAxios";

export default {
    namespaced: true,

    state: {
        checkList: {
            Id: 0,
            title: null,
            project: [],
        },
        checkListss: [],
        loading: false,
        recordsTotal: 0,
        companyChecklistTemp: [],
        companyRecordTotal: 0,
        companyLoading: false
    },

    getters: {

        _getCheckList: (state) => {
            return state.checkListss
        },
        _getLoading: (state) => {
            return state.loading
        },
        _getrecordsTotal: (state) => {
            return state.recordsTotal
        },
        _getCompanyCheckTemp: (state) => {
            return state.companyChecklistTemp
        },
        _getCompanyTempTotal: (state) => {
            return state.totalChecklistTemp
        },
        _getCompanyLoading: (state) => {
            return state.companyLoading
        }
    },

    mutations: {

        SET_CHECKLIST: (state, Data) => {
            state.checkListss = []
            state.recordsTotal = Data.TotalItemsCount
            if (Data.ListItems.length > 0) {
                Data.ListItems.forEach(item => {
                    state.checkListss.push(item)
                });
            }
            state.loading = false
        },

        SET_COMPANY_CHECKLIST_TEMP: (state, Data) => {
            state.companyChecklistTemp = Data.ListItems;
            state.totalChecklistTemp = Data.TotalItemsCount;
        }
    },

    actions: {
        async GET_CHECKLISTS_QUESTİON(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/TemplateQuestion/GetAll", payload).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    } else {
                        resolve([])
                    }
                })

            })
        },
        async GET_CHECKLIST(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/TemplateChecklist/Get/${payload}`).then(Response => {
                    if (Response.data.Success) {
                        resolve(Response.data.Data)
                    }
                    else {
                        resolve(false)
                    }
                })
            })
        },


        async GET_ALL_CHECKLIST({ commit, state }, payload) {
            state.loading = true;
            await appAxios.post("/admin/TemplateChecklist/GetAll", payload).then(Response => {
                commit("SET_CHECKLIST", Response.data.Data)
            }).catch(() => state.loading = false)

        },
        async CREATE_OR_UPDATE_CHECKLIST({ context }, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/TemplateChecklist/CreateOrUpdate", payload).then(Response => {
                    resolve(Response.data.Success)
                })
            })
        },

        async DELETE_CHECKLIST({ dispatch }, payload) {
            await appAxios.post("/admin/TemplateChecklist/Delete", payload[0]).then(response => {
                if (response.data.Success) {
                    dispatch("GET_ALL_CHECKLIST", payload[1])
                }
            })
        },

        async CHECKLIST_COPY(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/TemplateChecklist/Copy?id=${payload}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data)
                    }
                })
            })
        },

        async GET_COMPANY_TEMP_CHECKLIST({ commit }, payload) {
            await appAxios.post("/admin/TemplateChecklist/GetCompanyTemplateChecklists", payload).then(response => {
                commit("SET_COMPANY_CHECKLIST_TEMP", response.data.Data)

            })
        },

        async ADD_CHECK_TEMPLATES_COMPANY(context, payload) {
            await appAxios.post("/admin/TemplateChecklist/AddTemplatesToCompany", payload).then((response) => {
                if (response.data.Success) {
                    context.dispatch("GET_COMPANY_TEMP_CHECKLIST", { page: 1, pageSize: 10, companyId: payload.companyId })
                    context.dispatch("CHECKLIST_NO_MAPPED", { page: 1, pageSize: 10, companyId: payload.companyId })
                }

            })

        },


        // async PROJECT_ADD_CHECKLIST(context, payload) {
        //     return new Promise(resolve => {
        //         appAxios.post("/admin/Project/AddChecklistToProject", payload).then(response => {
        //             if (response.data.Success) {

        //                 context.dispatch("GET_PROJECT_CHECKLIST", {
        //                     page: 1,
        //                     pageSize: 10,
        //                     projectId: payload.projectId,
        //                 })
        //             }
        //             resolve(response.data.Success)
        //         })
        //     })
        // },

        async CHECKLIST_NO_MAPPED(_, payload) {
            return new Promise((resolve, reject) => {
                appAxios.post("/admin/TemplateChecklist/GetChecklistsNotMappedToCompany", payload).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        reject(false)
                    }
                })
            })
        },
        async DELETE_CHECKLIST_TEMPLATE(context, payload) {
            await appAxios.post("/admin/TemplateChecklist/DeleteCompanyChecklist", payload).then(
                response => {
                    if (response.data.Success) {
                        context.dispatch("GET_COMPANY_TEMP_CHECKLIST", { page: 1, pageSize: 10, companyId: parseInt(payload.companyId) })
                    }
                }
            )

        },
        async CHECKLIST_NEW_CREATE(_, payload) {
            return new Promise((resolve) => {
                appAxios.get(`/admin/TemplateChecklist/CreateChecklistByTemplateId?templateChecklistId=${payload}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(false)
                    }
                })
            })
        }







    }
}